import * as React from 'react';
const SvgLoyalty = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M8 13.55a1.45 1.45 0 0 1-.475-.083A1.102 1.102 0 0 1 7.1 13.2l-1.15-1.05a45.572 45.572 0 0 1-3.192-3.208C1.808 7.88 1.333 6.71 1.333 5.433c0-1.044.35-1.916 1.05-2.616.7-.7 1.572-1.05 2.617-1.05.589 0 1.144.125 1.666.375.523.25.967.591 1.334 1.025a3.97 3.97 0 0 1 1.333-1.025A3.811 3.811 0 0 1 11 1.767c1.044 0 1.916.35 2.616 1.05.7.7 1.05 1.572 1.05 2.616 0 1.278-.472 2.45-1.416 3.517a39.916 39.916 0 0 1-3.217 3.217L8.9 13.2a1.102 1.102 0 0 1-.425.267A1.45 1.45 0 0 1 8 13.55M7.366 4.5c-.322-.456-.666-.803-1.033-1.042C5.966 3.22 5.522 3.1 5 3.1c-.667 0-1.223.222-1.667.667-.444.444-.667 1-.667 1.666 0 .578.206 1.192.617 1.842.411.65.903 1.28 1.475 1.892a25.63 25.63 0 0 0 1.767 1.716c.605.534 1.097.973 1.475 1.317.377-.344.87-.783 1.475-1.317a25.63 25.63 0 0 0 1.766-1.716 12.721 12.721 0 0 0 1.475-1.892c.412-.65.617-1.264.617-1.842 0-.666-.222-1.222-.667-1.666-.444-.445-1-.667-1.666-.667-.523 0-.967.12-1.334.358-.366.24-.71.586-1.033 1.042A.759.759 0 0 1 8 4.833a.759.759 0 0 1-.633-.333"
    />
  </svg>
);
export default SvgLoyalty;
